import { render, staticRenderFns } from "./PricingHeroV2.vue?vue&type=template&id=aa6b3712&scoped=true&"
import script from "./PricingHeroV2.vue?vue&type=script&lang=js&"
export * from "./PricingHeroV2.vue?vue&type=script&lang=js&"
import style0 from "./PricingHeroV2.vue?vue&type=style&index=0&id=aa6b3712&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6b3712",
  null
  
)

export default component.exports